/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tooltip,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppContext from '../../../context/appContext'
import { useExclusionAreaTypes } from '../../../hooks/data/useExclusionAreaTypes'
import { useFarmSubdivisions } from '../../../hooks/data/useFarmSubdivisions'
import { useSaveFarmMapping } from '../../../hooks/data/useSaveFarmMapping'
import {
  getStoredMapeoDone,
  setStoredMapeoDone,
} from '../../../services/appPreferences/farmMappingStorage'
import { checkFeaturesOverlap } from '../../../services/farmMapping/checkFeaturesOverlap'
import { errors } from '../../../services/ruutsApi/errors'
import { getSelectedYears } from '../../../utils/FarmLayers/exportMapeo'
import {
  deleteOutsiderFeatures,
  perimetersToMultiPolygon,
} from '../../../utils/FarmLayers/perimeter'
import { useProcessLoading } from '../../../utils/Loading/useProcessLoading'
import { customSnackbarError } from '../../../utils/Snackbar/Snackbar'
import { PANEL_HEIGHT, PANEL_HEIGHT_VALUE_PX } from '../../../utils/constants'
import { getRandomColor } from '../../../utils/mapDrawHandle'
import { messages } from '../../../utils/messages/index'
import { userRoles } from '../../../utils/userRoles'
import { displayErrorMessageModes } from '../../GlobalLoadingModal/GlobalLoadingModal'
import CategorizationConfirm from '../modals/CategorizationConfirm'
import AlertBanner from './AlertBanner'
import { findDuplicatesFeaturesNamesAndExclusionAreaTypeIdIndexes } from './findDuplicatesFeaturesNamesAndExclusionAreaTypeIdIndexes'
import { findDuplicatesFeaturesNamesIndexes } from './findDuplicatesFeaturesNamesIndexes'
import { findInvalidFeaturesNamesIndexes } from './findInvalidFeaturesNamesIndexes'
import { hasValidExclusionAreaType } from './hasValidExclusionAreaType'
import { LayerPanel } from './LayerPanel'
import { renameExclusionArea } from './renameExclusionArea'
import { withExclusionAreaType } from './withExclusionAreaType'
import { withGrazingManagement } from './withGrazingManagement'
import { withOtherName } from './withOtherName'
import YearSelector from './YearSelector'

const categoriesPanels = {
  carbonInstances: {
    type: 'carbonInstances',
    panelName: 'carbonInstancesPanel',
  },
  exclusionAreas: {
    type: 'exclusion',
    panelName: 'exclusionAreasPanel',
  },
  monitoringSites: {
    type: 'monitoringSites',
    panelName: 'monitoringPanel',
  },
  unassigned: {
    type: 'unassigned',
    panelName: 'unassignedPanel',
  },
  unassignedPoints: {
    type: 'unassignedPoints',
    panelName: 'unassignedPointsPanel',
  },
  paddocks: {
    type: 'paddocks',
    panelName: 'paddocksPanel',
  },
  samplingAreas: {
    type: 'estratas',
    panelName: 'samplingAreasPanel',
  },
  perimeter: {
    type: 'perimeter',
    panelName: 'perimeterPanel',
  },
  otherSites: {
    type: 'otherSites',
    panelName: 'otherSitesPanel',
  },
  otherPolygons: {
    type: 'otherPolygons',
    panelName: 'otherPolygonsPanel',
  },
}

const successfulValidation = null

const saveFailureLayerLabels = {
  monitoringSites: 'Sitio de monitoreo',
  otherPolygons: 'Otro polígono',
  otherSites: 'Otro sitio',
}

const buildSaveFailuresMessage = failures =>
  `El establecimiento se guardó, pero no se pudieron crear: ${failures
    .map(
      ({ layer, name, error }) => `${saveFailureLayerLabels[layer]} "${name}" (${error.message})`,
    )
    .join('; ')}`

// Module-level so the highest-year effect keyed on the list does not rerun on every render.
const EMPTY_YEARS = []

const ShowFolders = ({
  actualYearId,
  carbonInstances,
  center,
  etapa,
  exclusionAreas,
  fileType,
  handleActualYearId,
  handleCarbonInstances,
  handleDownload,
  handleEtapa,
  handleExclusionAreas,
  handleExclusionAreasSaved,
  handleFileType,
  handleIncludeProjectArea,
  handleIncludeSoilInfo,
  handleMappingSaved,
  handleMapUpdate,
  handleMonitoringSites,
  handleOtherPolygons,
  handleOtherSites,
  handlePaddocks,
  handlePerimeter,
  handleSamplingAreas,
  handleOtherLayersSaved,
  handleSamplingAreasSaved,
  handleSaved,
  handleUnassigned,
  handleUnassignedPoints,
  includeProjectArea,
  includeSoilInfo,
  monitoringSites,
  otherPolygons,
  otherSites,
  paddocks,
  perimeter,
  samplingAreas,
  saved,
  unassigned,
  unassignedPoints,
}) => {
  const { programConfig, currentFarm, setPartialChanges, userRoleSelected } = useContext(AppContext)

  const [alert, setAlert] = useState(false)
  const [modalConfirmationOpen, setModalConfirmationOpen] = useState(false)
  const [years, setYears] = useState([])
  const [expandedPanels, setExpandedPanels] = useState({})
  const [perimeterValidation, setPerimeterValidation] = useState(successfulValidation)
  const [exclusionAreasValidation, setExclusionAreasValidation] = useState(successfulValidation)
  const [unassignedValidation] = useState(successfulValidation)
  const [paddocksValidation, setPaddocksValidation] = useState(successfulValidation)
  const [samplingAreasValidation, setSamplingAreasValidation] = useState(successfulValidation)
  const [monitoringSitesValidation, setMonitoringSitesValidation] = useState(successfulValidation)
  const [otherSitesValidation] = useState(successfulValidation)
  const [otherPolygonsValidation] = useState(successfulValidation)
  const [unassignedPointsValidation, setUnassignedPointsValidation] = useState(successfulValidation)
  const [featuresAreValid, setFeaturesAreValid] = useState(false)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const { processLoading } = useProcessLoading()
  const { data: exclusionAreaTypes } = useExclusionAreaTypes({ programId: currentFarm?.programId })
  const { mutateAsync: saveMapping } = useSaveFarmMapping({ farmId: currentFarm?.id })
  const { data: farmSubdivisions } = useFarmSubdivisions({
    farmId: currentFarm?.id,
    enabled: !!saved,
  })
  const downloadableYears = useMemo(
    () =>
      farmSubdivisions?.map(subdivision => ({ id: subdivision.id, value: subdivision.year })) ??
      EMPTY_YEARS,
    [farmSubdivisions],
  )

  const navigate = useNavigate()

  const handleOpen = () => {
    setModalConfirmationOpen(true)
  }
  const handleClose = () => {
    setModalConfirmationOpen(false)
  }

  const handleSaveCategorization = async () => {
    await processLoading({
      loadingMessage: 'Guardando establecimiento...',
      displayErrorMessageMode: displayErrorMessageModes.dialog,
      doAction: async () => {
        const selectedYears = getSelectedYears(years, etapa)

        const multiPolygonPerimeter = perimetersToMultiPolygon(perimeter)

        const filteredLayers = deleteOutsiderFeatures(
          multiPolygonPerimeter,
          paddocks,
          handlePaddocks,
          samplingAreas,
          handleSamplingAreas,
          monitoringSites,
          handleMonitoringSites,
          exclusionAreas,
          handleExclusionAreas,
          otherPolygons,
          handleOtherPolygons,
          otherSites,
          handleOtherSites,
        )

        // If there is sampling area superposition, show alert and throw an error to stop processLoading process
        checkFeaturesOverlap(filteredLayers.samplingAreas)

        handleUnassigned(null)
        handleUnassignedPoints(null)

        // If there is no superposition, save
        const { failures } = await saveMapping({
          farm: currentFarm,
          selectedYears,
          perimeter: multiPolygonPerimeter,
          center,
          ...filteredLayers,
          exclusionAreaTypes,
        })

        handleSamplingAreasSaved?.()
        handleOtherLayersSaved?.()
        handleExclusionAreasSaved?.()
        await handleMappingSaved?.()

        handleSaved(true)
        setPartialChanges(false)

        // Everything the chain reached is persisted, so the drafts are dropped first and the
        // per-feature rejections are reported afterwards, by name, in the loading modal dialog.
        if (failures.length) {
          throw new errors.BusinessEntityError({ message: buildSaveFailuresMessage(failures) })
        }
      },
    })
    handleClose()
  }

  const handleYears = newYears => {
    setYears(newYears)
  }

  const handleCancelShowFolders = () => {
    handleCarbonInstances(null)
    handlePerimeter(null)
    handlePaddocks(null)
    handleSamplingAreas(null)
    handleMonitoringSites(null)
    handleExclusionAreas(null)
    handleUnassigned(null)
    handleUnassignedPoints(null)
    handleOtherPolygons(null)
    handleOtherSites(null)
    handleEtapa('inicial')
    setPartialChanges(false)
    handleMapUpdate()
  }

  const handleCloseAlert = () => {
    setAlert(false)
    setStoredMapeoDone(false)
  }

  const handleLayerTypeChange = (newFeature, oldType, newType) => {
    // remove feature from the oldType
    switch (oldType) {
      case 'carbonInstances':
        const newCarbonInstances = carbonInstances.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleCarbonInstances(newCarbonInstances)
        break
      case 'perimeter':
        const newPerimeters = perimeter.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handlePerimeter(newPerimeters)
        break
      case 'paddocks':
        const newPaddocks = paddocks.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handlePaddocks(newPaddocks)
        break
      case 'estratas':
        const newSamplingAreas = samplingAreas.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleSamplingAreas(newSamplingAreas)
        break
      case 'exclusion':
        const newExclusionAreas = exclusionAreas.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        delete newFeature.properties.exclusionAreaTypeId
        handleExclusionAreas(newExclusionAreas)
        break
      case 'otherPolygons':
        const newOtherPolygons = otherPolygons.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleOtherPolygons(newOtherPolygons)
        break
      case 'otherSites':
        const newOtherSites = otherSites.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleOtherSites(newOtherSites)
        break
      case 'monitoringSites':
        const newMonitoringSites = monitoringSites.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleMonitoringSites(newMonitoringSites)
        break
      case 'unassigned':
        const newUnassigned = unassigned.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleUnassigned(newUnassigned)
        break
      case 'unassignedPoints':
        const newUnassignedPoints = unassignedPoints.filter(p => {
          return p.properties.id !== newFeature.properties.id
        })
        handleUnassignedPoints(newUnassignedPoints)
        break
      default:
        break
    }

    // add feature to the newType
    switch (newType) {
      case 'perimeter':
        const newPerimeters = perimeter?.length ? [...perimeter] : []
        newFeature.properties.featureGroup = 'perimeter'
        newPerimeters.push(newFeature)
        handlePerimeter(newPerimeters)
        break
      case 'paddocks':
        const newPaddocks = paddocks?.length ? [...paddocks] : []
        newFeature.properties.featureGroup = 'paddocks'
        newPaddocks.push(newFeature)
        handlePaddocks(newPaddocks)
        break
      case 'estratas':
        const newEstratas = samplingAreas?.length ? [...samplingAreas] : []
        // Add color
        if (!newFeature.properties.color) {
          const color = getRandomColor()
          newFeature.properties.color = color
        }
        newEstratas.push(newFeature)
        handleSamplingAreas(newEstratas)
        break
      case 'exclusion':
        const newExclusionAreas = exclusionAreas?.length ? [...exclusionAreas] : []
        newFeature.properties.featureGroup = 'exclusion'
        newExclusionAreas.push(newFeature)
        handleExclusionAreas(newExclusionAreas)
        break
      case 'otherPolygons':
        const newOtherPolygons = otherPolygons ? [...otherPolygons] : []
        newFeature.properties.featureGroup = 'otherPolygons'
        newOtherPolygons.push(newFeature)
        handleOtherPolygons(newOtherPolygons)
        break
      case 'carbonInstances':
        const newCarbonInstances = carbonInstances ? [...carbonInstances] : []
        newFeature.properties.featureGroup = 'carbonInstances'
        newCarbonInstances.push(newFeature)
        handleCarbonInstances(newCarbonInstances)
        break
      case 'unassigned':
        const newUnassigned = unassigned ? [...unassigned] : []
        newFeature.properties.featureGroup = 'unassigned'
        newUnassigned.push(newFeature)
        handleUnassigned(newUnassigned)
        break
      case 'monitoringSites':
        const newMonitoringSites = monitoringSites?.length ? [...monitoringSites] : []
        newFeature.properties.featureGroup = 'monitoringSites'
        newMonitoringSites.push(newFeature)
        handleMonitoringSites(newMonitoringSites)
        break
      case 'otherSites':
        const newOtherSites = otherSites?.length ? [...otherSites] : []
        newFeature.properties.featureGroup = 'otherSites'
        newOtherSites.push(newFeature)
        handleOtherSites(newOtherSites)
        break
      case 'unassignedPoints':
        const newUnassignedPoints = unassignedPoints?.length ? [...unassignedPoints] : []
        newFeature.properties.featureGroup = 'unassignedPoints'
        newUnassignedPoints.push(newFeature)
        handleUnassignedPoints(newUnassignedPoints)
        break
      default:
        break
    }

    handleMapUpdate()
  }

  const handleExclusionAreaTypeChange = (newFeature, newType) => {
    // Every exclusion row hydrates in the same render, so a value built from the render closure
    // would drop the sibling rows' types. The updater form makes the writes cumulative.
    handleExclusionAreas(prev => withExclusionAreaType(prev, newFeature.properties.id, newType))

    handleMapUpdate()
  }

  const handleName = (newFeature, type, newName) => {
    const updateFeatureName = features =>
      features.map(feature =>
        feature.properties.id === newFeature.properties.id
          ? { ...feature, properties: { ...feature.properties, name: newName } }
          : feature,
      )

    switch (type) {
      case 'paddocks':
        handlePaddocks(updateFeatureName(paddocks))
        break
      case 'estratas':
        handleSamplingAreas(updateFeatureName(samplingAreas))
        break
      case 'exclusion':
        handleExclusionAreas(prev => renameExclusionArea(prev, newFeature.properties.id, newName))
        break
      case 'otherPolygons':
        handleOtherPolygons(updateFeatureName(otherPolygons))
        break
      case 'monitoringSites':
        handleMonitoringSites(updateFeatureName(monitoringSites))
        break
      default:
        break
    }
  }

  const handleOtherName = (newFeature, newOtherName) => {
    handleExclusionAreas(prev => withOtherName(prev, newFeature.properties.id, newOtherName))

    handleMapUpdate()
  }

  const handleHasGrazingManagement = (newFeature, newHasGrazingManagement) => {
    try {
      handleExclusionAreas(prev =>
        withGrazingManagement(prev, newFeature.properties.id, newHasGrazingManagement),
      )

      handleMapUpdate()
    } catch (error) {
      customSnackbarError(
        'Error al cambiar el uso de manejo, por favor intente nuevamente',
        error,
        enqueueSnackbar,
        closeSnackbar,
      )
    }
  }

  const validatePaddocksFeatures = useCallback(
    pads => {
      if (!pads?.length) {
        setPaddocksValidation(null)
        return true
      }

      // Check years selected
      if (years && !saved) {
        let yearsMissing = pads && pads.length > 0
        years.forEach(year => {
          if (year.selected) {
            yearsMissing = false
          }
        })
        if (yearsMissing) {
          setPaddocksValidation({
            errorsIndexes: [],
            message: 'Debe seleccionar al menos un año',
          })
          return false
        }
      }

      let errorsIndexes = findInvalidFeaturesNamesIndexes(pads)
      if (errorsIndexes.length > 0) {
        setPaddocksValidation({
          errorsIndexes,
          message: messages.getMessage(messages.keys.ERROR_INVALID_LAYER_NAME_MESSAGE),
        })
        return false
      }

      // Check if paddock names are duplicated
      errorsIndexes = findDuplicatesFeaturesNamesIndexes(pads)
      if (errorsIndexes.length > 0) {
        setPaddocksValidation({
          errorsIndexes,
          message: messages.getMessage(
            messages.keys.ERROR_CANNOT_EDIT_CATEGORY_WITH_DUPLICATES_NAMES_MESSAGE,
            [messages.keys.FARM_SUBDIVISION_GEOMETRY_TYPE],
          ),
        })
        return false
      }

      setPaddocksValidation(null)
      return true
    },
    [years, saved],
  )

  useEffect(() => {
    if (!saved) validatePaddocksFeatures(paddocks)
  }, [saved, validatePaddocksFeatures, paddocks])

  const validateSamplingAreasFeatures = useCallback(sA => {
    if (!sA?.length) {
      setSamplingAreasValidation(null)
      return true
    }

    let errorsIndexes = findInvalidFeaturesNamesIndexes(sA)
    if (errorsIndexes.length > 0) {
      setSamplingAreasValidation({
        errorsIndexes,
        message: messages.getMessage(messages.keys.ERROR_INVALID_LAYER_NAME_MESSAGE),
      })
      return false
    }

    errorsIndexes = findDuplicatesFeaturesNamesIndexes(sA)
    if (errorsIndexes.length > 0) {
      setSamplingAreasValidation({
        errorsIndexes,
        message: messages.getMessage(
          messages.keys.ERROR_CANNOT_EDIT_CATEGORY_WITH_DUPLICATES_NAMES_MESSAGE,
          [messages.keys.SAMPLING_AREA_GEOMETRY_TYPE],
        ),
      })
      return false
    }

    setSamplingAreasValidation(null)
    return true
  }, [])

  useEffect(() => {
    if (!saved) validateSamplingAreasFeatures(samplingAreas)
  }, [saved, validateSamplingAreasFeatures, samplingAreas])

  const validateExclusionAreasFeatures = useCallback(
    eA => {
      if (!eA?.length) {
        setExclusionAreasValidation(null)
        return true
      }

      let errorsIndexes = findInvalidFeaturesNamesIndexes(eA)
      if (errorsIndexes.length > 0) {
        setExclusionAreasValidation({
          errorsIndexes,
          message: messages.getMessage(messages.keys.ERROR_INVALID_LAYER_NAME_MESSAGE),
        })
        return false
      }

      // Check duplicate on exclusion type and name
      errorsIndexes = findDuplicatesFeaturesNamesAndExclusionAreaTypeIdIndexes(eA)
      if (errorsIndexes?.length > 0) {
        setExclusionAreasValidation({
          errorsIndexes,
          message: messages.getMessage(
            messages.keys.ERROR_CANNOT_EDIT_CATEGORY_WITH_DUPLICATES_NAMES_AND_TYPE_MESSAGE,
            [messages.keys.EXCLUSION_AREA_GEOMETRY_TYPE],
          ),
        })
        return false
      }

      const unassignedExclusionAreaTypesIndexes = eA
        ?.map((exclusionArea, index) =>
          hasValidExclusionAreaType(exclusionArea?.properties, exclusionAreaTypes)
            ? undefined
            : index,
        )
        .filter(index => index !== undefined)

      if (unassignedExclusionAreaTypesIndexes?.length > 0) {
        setExclusionAreasValidation({
          errorsIndexes: unassignedExclusionAreaTypesIndexes,
          message: 'Se debe asignar el tipo de área de exclusión',
        })
        return false
      }

      setExclusionAreasValidation(null)
      return true
    },
    [exclusionAreaTypes],
  )

  useEffect(() => {
    if (!saved) validateExclusionAreasFeatures(exclusionAreas)
  }, [saved, validateExclusionAreasFeatures, exclusionAreas])

  const validatePerimeterFeature = useCallback(per => {
    if (!per?.length) {
      setPerimeterValidation({
        message: messages.getMessage(
          messages.keys.ERROR_CANNOT_EDIT_FARM_PERIMETER_REQUIRED_MESSAGE,
        ),
      })
      return false
    }

    const invalidPerimetersIndexes = per
      ?.map((p, index) => (p?.geometry !== undefined ? index : undefined))
      .filter(index => index !== undefined)

    if (!invalidPerimetersIndexes?.length) {
      setPerimeterValidation({
        errorsIndexes: invalidPerimetersIndexes,
        message: messages.getMessage(
          messages.keys.ERROR_CANNOT_EDIT_FARM_PERIMETER_REQUIRED_MESSAGE,
        ),
      })
      return false
    }

    setPerimeterValidation(null)
    return true
  }, [])

  useEffect(() => {
    if (!saved) validatePerimeterFeature(perimeter)
  }, [saved, validatePerimeterFeature, perimeter])

  const validateUnassignedPointsFeatures = useCallback(uP => {
    if (!uP?.length) {
      setUnassignedPointsValidation(null)
      return true
    }

    const errorsIndexes = findDuplicatesFeaturesNamesIndexes(uP)
    if (errorsIndexes?.length > 0) {
      setUnassignedPointsValidation({
        errorsIndexes,
        message: messages.getMessage(
          messages.keys.ERROR_CANNOT_EDIT_CATEGORY_WITH_DUPLICATES_NAMES_MESSAGE,
          [messages.keys.UNSIGNED_POINT_GEOMETRY_TYPE],
        ),
      })
      return false
    }

    setUnassignedPointsValidation(null)
    return true
  }, [])

  useEffect(() => {
    if (!saved) validateUnassignedPointsFeatures(unassignedPoints)
  }, [saved, validateUnassignedPointsFeatures, unassignedPoints])

  const validateMonitoringSitesFeatures = useCallback(mS => {
    if (!mS?.length) {
      setMonitoringSitesValidation(null)
      return true
    }

    let errorsIndexes = findInvalidFeaturesNamesIndexes(mS)
    if (errorsIndexes.length > 0) {
      setMonitoringSitesValidation({
        errorsIndexes,
        message: messages.getMessage(messages.keys.ERROR_INVALID_LAYER_NAME_MESSAGE),
      })
      return false
    }

    // Check if monitoring site names are duplicated
    errorsIndexes = findDuplicatesFeaturesNamesIndexes(mS)
    if (errorsIndexes.length > 0) {
      setMonitoringSitesValidation({
        errorsIndexes,
        message: messages.getMessage(
          messages.keys.ERROR_CANNOT_EDIT_CATEGORY_WITH_DUPLICATES_NAMES_MESSAGE,
          [messages.keys.MONITORING_SITE_GEOMETRY_TYPE],
        ),
      })
      return false
    }

    setMonitoringSitesValidation(null)
    return true
  }, [])

  useEffect(() => {
    if (!saved) validateMonitoringSitesFeatures(monitoringSites)
  }, [saved, monitoringSites, validateMonitoringSitesFeatures])

  const handleCheckForRequiredFields = () => {
    const featuresToValidate = [
      { feature: perimeter, validator: validatePerimeterFeature },
      { feature: unassignedPoints, validator: validateUnassignedPointsFeatures },
      { feature: paddocks, validator: validatePaddocksFeatures },
      { feature: samplingAreas, validator: validateSamplingAreasFeatures },
      { feature: exclusionAreas, validator: validateExclusionAreasFeatures },
      { feature: monitoringSites, validator: validateMonitoringSitesFeatures },
    ]

    const allValid = featuresToValidate.every(({ validator, feature }) => validator(feature))

    if (allValid) {
      handleOpen()
    }
  }

  const handleRemoveFeature = (newFeature, type) => {
    if (type === 'unassigned') {
      const newUnassigned = unassigned
        .map(u => {
          if (u.properties.id !== newFeature.properties.id) {
            return u
          }
          return null
        })
        .filter(u => {
          return u !== null
        })
      handleUnassigned(newUnassigned)
    } else if (type === 'unassignedPoints') {
      const newUnassignedPoints = unassignedPoints
        .map(unassignedPoint => {
          if (unassignedPoint.properties.id !== newFeature.properties.id) {
            return unassignedPoint
          }
          return null
        })
        .filter(unassignedPoint => {
          return unassignedPoint !== null
        })
      handleUnassignedPoints(newUnassignedPoints)
    }
  }

  useEffect(() => {
    if (years.length === 0) {
      const newYears = programConfig.farmSubdivisionsYearsAllowed
        .filter(farmSubdivisionYearAllowed => !Number.isNaN(farmSubdivisionYearAllowed)) // On KML mapeo creation, only years are allowed (Not ex-posted years)
        .map(farmSubdivisionYearAllowed => {
          return { value: farmSubdivisionYearAllowed, selected: false }
        })
      setYears(newYears)
    }
  }, [years, programConfig])

  useEffect(() => {
    setAlert(getStoredMapeoDone() ?? true)
  }, [alert])

  useEffect(() => {
    if (etapa === 'showingFoldersApi') {
      handleSaved(true)
    }
  }, [etapa, handleSaved])

  useEffect(() => {
    if (saved && downloadableYears.length > 0 && !actualYearId) {
      const highestYear = downloadableYears.reduce((prev, current) => {
        return prev.value > current.value ? prev : current
      })
      handleActualYearId(highestYear.id)
    }
  }, [downloadableYears, actualYearId, handleActualYearId, saved])

  useEffect(() => {
    const validations = [
      perimeterValidation,
      exclusionAreasValidation,
      unassignedValidation,
      paddocksValidation,
      samplingAreasValidation,
      monitoringSitesValidation,
      unassignedPointsValidation,
    ]

    setFeaturesAreValid(validations.every(validation => !validation))
  }, [
    perimeterValidation,
    exclusionAreasValidation,
    unassignedValidation,
    paddocksValidation,
    samplingAreasValidation,
    monitoringSitesValidation,
    unassignedPointsValidation,
  ])

  const handleChange = panel => () => {
    const newHandlePanels = { ...expandedPanels }
    // Toggle the panel panel selected in order to expand or collapse it
    newHandlePanels[panel.panelName] = !newHandlePanels[panel.panelName]
    setExpandedPanels(newHandlePanels)
  }

  const selectedYear = downloadableYears.find(year => year.id === actualYearId)?.value

  return (
    <Box
      sx={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: saved ? PANEL_HEIGHT : `calc(100vh - ${PANEL_HEIGHT_VALUE_PX + 60}px)`,
      }}
    >
      <AlertBanner
        alert={alert}
        etapa={etapa}
        exclusionAreas={exclusionAreas}
        handleCloseAlert={handleCloseAlert}
        paddocks={paddocks}
        perimeter={perimeter}
        samplingAreas={samplingAreas}
        saved={saved}
        unassigned={unassigned}
      />
      <Box
        sx={{
          width: '100%',
          padding: '10px',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          minHeight: '125px',
        }}
      >
        {saved && downloadableYears.length > 0 ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              py: 1,
              px: 4,
            }}
            width="100%"
          >
            <Typography
              minWidth="150px"
              sx={{
                fontSize: 14,
                fontWeight: 600,
                pr: 2,
              }}
            >
              Seleccionar el año del loteo a visualizar
            </Typography>
            <Box sx={{ width: '100px' }}>
              <FormControl fullWidth>
                <InputLabel id="year-select-label">Año</InputLabel>
                <Select
                  id="year-select"
                  label="Año"
                  labelId="year-select-label"
                  value={actualYearId}
                  onChange={e => {
                    handleActualYearId(e.target.value)
                  }}
                >
                  {downloadableYears.map(year => (
                    <MenuItem key={year.id} value={year.id}>
                      {year.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        ) : null}
        {unassigned?.length > 0 && !saved && (
          <LayerPanel
            categoryPanel={categoriesPanels.unassigned}
            color="#f5bfba"
            elements={unassigned}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleUnassigned}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            handleRemoveFeature={handleRemoveFeature}
            saved={saved}
            title="Areas sin asignar"
            validation={unassignedValidation}
          />
        )}
        {unassignedPoints?.length > 0 && !saved && (
          <LayerPanel
            categoryPanel={categoriesPanels.unassignedPoints}
            color="#f5bfba"
            elements={unassignedPoints}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleUnassignedPoints}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            handleRemoveFeature={handleRemoveFeature}
            saved={saved}
            title="Puntos sin asignar"
            validation={unassignedPointsValidation}
          />
        )}
        {perimeter?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.perimeter}
            color="#f5f2ba"
            elements={perimeter}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handlePerimeter}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Perímetro"
            validation={perimeterValidation}
          />
        )}
        {paddocks?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.paddocks}
            color="#dcbfd4"
            elements={paddocks}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handlePaddocks}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Lotes"
            validation={paddocksValidation}
            year={selectedYear}
          >
            {etapa === 'showingFoldersArchivo' && !saved && (
              <YearSelector handleYears={handleYears} years={years} />
            )}
          </LayerPanel>
        )}
        {samplingAreas?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.samplingAreas}
            color="#c2d9ba"
            elements={samplingAreas}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleSamplingAreas}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Estratos"
            validation={samplingAreasValidation}
          />
        )}
        {exclusionAreas?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.exclusionAreas}
            color="#c2bfba"
            elements={exclusionAreas}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleExclusionAreaTypeChange={handleExclusionAreaTypeChange}
            handleFeatureChange={handleExclusionAreas}
            handleHasGrazingManagement={handleHasGrazingManagement}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            handleOtherName={handleOtherName}
            saved={saved}
            title="Áreas de exclusión"
            validation={exclusionAreasValidation}
          />
        )}
        {otherPolygons?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.otherPolygons}
            color="#f5e6e3"
            elements={otherPolygons}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleOtherPolygons}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Otras áreas"
            validation={otherPolygonsValidation}
          />
        )}
        {monitoringSites?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.monitoringSites}
            color="#277fca"
            elements={monitoringSites}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleMonitoringSites}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Sitios de monitoreo"
            validation={monitoringSitesValidation}
          />
        )}
        {carbonInstances?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.carbonInstances}
            color="#ffb3b3"
            elements={carbonInstances}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleCarbonInstances}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Instancias de carbono"
            validation={null}
          />
        )}
        {otherSites?.length > 0 && (
          <LayerPanel
            categoryPanel={categoriesPanels.otherSites}
            color="#ffd699"
            elements={otherSites}
            expandedPanels={expandedPanels}
            handleChange={handleChange}
            handleFeatureChange={handleOtherSites}
            handleLayerTypeChange={handleLayerTypeChange}
            handleMapUpdate={handleMapUpdate}
            handleName={handleName}
            saved={saved}
            title="Otros sitios"
            validation={otherSitesValidation}
          />
        )}
        {saved ? (
          <Grid container>
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                padding: 2,
              }}
              xs={12}
            >
              <Divider sx={{ width: '100%' }} />
            </Grid>
            {/* Manejo */}
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              xs={12}
            >
              <Typography fontSize={14} fontWeight={600}>
                Para cargar loteos y datos históricos
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                paddingBottom: 2,
              }}
              xs={12}
            >
              <Typography
                fontSize={14}
                fontWeight={600}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: '#277fca',
                }}
                onClick={() => {
                  navigate('/management')
                }}
              >
                {'Continuar con Manejo >'}
              </Typography>
            </Grid>
            {/* Monitoreo */}
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              xs={12}
            >
              <Typography fontSize={14} fontWeight={600}>
                Para visualizar o cargar datos para el trabajo a campo
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
              }}
              xs={12}
            >
              <Typography
                fontSize={14}
                fontWeight={600}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: '#277fca',
                }}
                onClick={() => {
                  navigate('/monitoring')
                }}
              >
                {'Continuar con Monitoreo >'}
              </Typography>
            </Grid>
          </Grid>
        ) : null}

        {saved ? (
          <Grid container>
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                padding: 2,
              }}
              xs={12}
            >
              <Divider sx={{ width: '100%' }} />
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                paddingX: 2,
              }}
              xs={12}
            >
              <Typography fontSize={16} fontWeight={600}>
                Exportar
              </Typography>
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                padding: 2,
              }}
              xs={12}
            >
              <FormControl>
                <FormLabel>Formato</FormLabel>
                <RadioGroup row value={fileType} onChange={handleFileType}>
                  <FormControlLabel control={<Radio />} label="KML" value="kml" />
                  <FormControlLabel control={<Radio />} label="GeoJSON" value="geojson" />
                </RadioGroup>
              </FormControl>
              {[userRoles.DataScientist, userRoles.Admin].includes(userRoleSelected) && (
                <FormControl>
                  <FormLabel>Incluir</FormLabel>
                  <FormControl sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                    <Checkbox
                      checked={includeSoilInfo}
                      name="includeSoilInfo"
                      onChange={handleIncludeSoilInfo}
                    />
                    <FormLabel>Información de suelo</FormLabel>
                  </FormControl>
                  <FormControl sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                    <Checkbox
                      checked={includeProjectArea}
                      name="includeProjectArea"
                      onChange={handleIncludeProjectArea}
                    />
                    <FormLabel>Área de proyecto</FormLabel>
                  </FormControl>
                </FormControl>
              )}
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                padding: 2,
              }}
              xs={12}
            >
              <Button
                color="primary"
                disabled={!fileType}
                variant="contained"
                onClick={handleDownload}
              >
                Descargar
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </Box>

      {!saved && etapa !== 'showingFoldersManual' ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: '10px',
            background: '#eaf4f6',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            width: (window.innerWidth / 3) * 1,
            zIndex: 900,
          }}
        >
          <Tooltip placement="top-end" title="Seleccionar un perímetro para poder guardar">
            <InfoOutlinedIcon />
          </Tooltip>
          <Button
            disabled={!featuresAreValid}
            variant="contained"
            onClick={handleCheckForRequiredFields}
          >
            Guardar
          </Button>
          <Button value="archivo" onClick={handleCancelShowFolders}>
            Cancelar
          </Button>
          <CategorizationConfirm
            buttonValue="showingFoldersArchivo"
            handleClose={handleClose}
            handleConfirm={handleSaveCategorization}
            open={modalConfirmationOpen}
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default ShowFolders
